import { Injectable } from "@angular/core";
import { WHITELABEL_DATA_LIST } from "./white-label-data-list";
import {
  Link,
  LogoLocation,
  WhiteLabelThemeData,
} from "app/core/white-label/white-label.type";
import { ThemeService } from "app/core/theme/theme.service";

/**
 * White-label static data
 */
@Injectable({
  providedIn: "root",
})
export class WhiteLabelService {
  constructor(private themeService: ThemeService) {}

  /**
   * Get the logo data for the location provided
   */
  public getCustomLogo(location: string | undefined): LogoLocation | undefined {
    if (location && this.data.logo) {
      return this.data.logo.find((logoLocation: LogoLocation) => {
        return logoLocation.location.includes(location);
      });
    }
    return undefined;
  }

  /**
   * Get links for portal by language
   */
  public getLinkForLanguage(link: Link, language: string): Link {
    if (typeof link.url === "object" && link.url !== null) {
      link.url = link.url[language] || link.url.default;
    }
    return link;
  }

  /**
   * Get white-label data: urls, contacts etc.
   */
  get data(): WhiteLabelThemeData {
    return WHITELABEL_DATA_LIST[this.themeService.getTheme()];
  }

  /**
   *
   * hides the reporting portal button by taking the info from the whitelabel data
   */
  get isHiddenReportingPortal(): boolean {
    const whitelabel: WhiteLabelThemeData = this.data;

    return whitelabel &&
      whitelabel.login &&
      whitelabel.login.isHiddenReportingPortalUrl
      ? whitelabel.login.isHiddenReportingPortalUrl
      : false;
  }
}
